module.exports = __webpack_public_path__ + "static/media/checkbox-01@2x.d5554fe4.png";